import React from "react";

import { InputContainer } from "./styles";

export function TextInput({ label, value, onChange, error, ...props }) {
	return (
		<InputContainer>
			<label htmlFor={label}>{label}</label>
			<input
				type="text"
				id={label}
				value={value}
				onChange={onChange}
				{...props}
			/>
			{error && <span className="form__form-group-error">{error}</span>}
		</InputContainer>
	);
}
